
import icon1 from '../images/icon/quote.png'
import avt1 from '../images/layouts/avt-02.png'
import avt2 from '../images/layouts/avt-021.png'
import avt3 from '../images/layouts/avt-022.png'


const dataTestimonials = [

    {
        id: 1,
        icon: icon1,
        text: ` “GMGN has transformed my trading experience with its user-friendly interface and real-time data. It's a game-changer“`,
        avt: avt1,
        name: 'Alice Johnson',
        position: ''
    },
    {
        id: 2,
        icon: icon1,
        text: `“The Sniping feature on GMGN allows me to seize opportunities instantly. It's an indispensable tool for any serious trader“`,
        avt: avt2,
        name: 'Bob Smith',
        position: ''
    },
    {
        id: 3,
        icon: icon1,
        text: `“With GMGN's Copy Trade feature, I've been able to learn from top traders and improve my strategies significantly“`,
        avt: avt3,
        name: 'Charlie Brown',
        position: ''
    },

]

export default dataTestimonials;